export const GET_TAGS = 'get_tags';
export const GET_SPICY_TAGS = 'get_spicy_tags';
export const GET_CUSTOMER = 'get_customer';
export const TOGGLE_PDP_MODAL = 'toggle_pdp_modal';
export const TOGGLE_RDP_MODAL = 'toggle_rdp_modal';
export const GET_CYO_PROMOS = 'get_cyo_promos';
